export const nl = {
  Interaction: "Interactie",
  Process: "Proces",
  Processs: "Proces",
  Integration: "Integratie",
  Services: "Service",
  Service: "Service",
  Data: "Data",
  Dependencies: "Afhankelijkheden",
  Standards: "Standaarden",
  Standard: "Standaard",
  Components: "Componenten",
  Suppliers: "Leveranciers",
  Reuse: "Hergebruik",
  Processes: "Processen",
  Products: "Producten",
  Name: "Naam",
  Repository: "Repository",
  Organization: "Organisatie",
  Organizations: "Organisaties",
  Layer: "Laag",
  Type: "Type",
  Layers: "Lagen",
  Status: "Status",
  Details: "Details",
  Table: "Tabel",
  Cards: "Kaarten",
  Search: "Zoeken",
  Installations: "Installaties",
  Software: "Software",
  Installation: "Installatie",
  Use: "Gebruiken",
  API: "API",
  Reuser: "Hergebruiker",
  interface: "Interactie",
  Interface: "Interactie",
  Username: "Gebruikersnaam",
  Password: "Wachtwoord",
  Send: "Versturen",
  Private: "Privé",
  Public: "Openbaar",
  Unknown: "Onbekend",
  Relations: "Relaties",
  About: "Over",
  Documentation: "Documentatie",
  Warning: "Waarschuwing",
  Version: "Versie",
  Close: "Sluiten",
  Initiatives: "Initiatieven",
  Development: "In Ontwikkeling",
  Stable: "Bruikbaar",
  Obsolete: "Uitgefaseerd",
  User: "Gebruiker",
  Login: "Inloggen",
  Logout: "Uitloggen",
  Applications: "Applicaties",
  Categories: "Categorieën",
  Category: "Categorie",
  Support: "Ondersteuning",
  Solutions: "Oplossingen",
  Control: "Sturing",
  Surveillance: "Bewaking",
  Directing: "Regievoering",
  Execution: "Uitvoering",
  Application: "Applicatie",
  Sources: "Bronnen",
  Contact: "Contact",
  Breadcrumbs: "Kruimelpad",
  Publications: "Publicaties",
  Usage: "Gebruik",
  Page: "Pagina",
  Limit: "Limiet",
  Email: "E-mail",
  Unavailable: "Niet beschikbaar",
  Rating: "Beoordeling",
  Points: "Punten",
  Description: "Beschrijving",
  Gold: "Goud",
  Silver: "Zilver",
  Bronze: "Brons",
  Configurations: "Configuraties",
  Attachments: "Bijlagen",
  License: "Licentie",
  Published: "Gepubliceerd",
  Modified: "Gewijzigd",
  Portal: "Portaal",
  Reference: "Referentie",
  Pagination: "Paginering",
  Extensions: "Extensies",
  "Open Catalogs": "OpenCatalogi",
  "Reusable components within the government": "Herbruikbare componenten binnen de overheid",
  "Information Models": "Informatiemodellen",
  "An initiative of": "Een initiatief van",
  "Privacy declaration": "Privacyverklaring",
  "All Open Catalog components": "Alle OpenCatalogi componenten",
  "View all components": "Bekijk alle componenten",
  "Show metadata": "Toon metadata",
  "Hide metadata": "Verberg metadata",
  "No title known": "Geen titel bekend",
  "No description known": "Geen description bekend",
  "No version known": "Geen version bekend",
  "Access url": "Toegangsurl",
  "One central place for reuse of information technology within the government":
    "Eén centrale plek voor hergebruik van informatietechnologie binnen de overheid",
  "No components found with active filters": "Geen componenten gevonden met actieve filters",
  "Back to components": "Terug naar componenten",
  "View component on GitHub": "Bekijk dit component op GitHub",
  "Schema's": "Schema's",
  "View component": "Bekijk component",
  "Check out the repository on GitHub": "Bekijk de repository op GitHub",
  "Search all components": "Doorzoek alle componenten",
  "Data models": "Datamodellen",
  "API's": "API's",
  "About OpenCatalogi": "Over OpenCatalogi",
  "This file comes from a 3rd party and can potentially be harmfull for your PC. Are you sure you want to download this?":
    "Dit bestand is afkomstig van een derde partij en kan schadelijk zijn voor uw computer. Weet u zeker dat u dit wilt downloaden?",
  "Go back": "Ga terug",
  "Management organization": "Beheerorganisatie",
  "No rating available": "Geen beoordeling beschikbaar",
  "Score calculation": "Score opbouw",
  "There is no organization available": "Er is geen organisatie beschikbaar",
  "No organization found": "Geen organisatie gevonden",
  "There is no description available": "Er is geen omschrijving beschikbaar",
  "My catalogi": "Mijn Catalogi",
  "Software products": "Software producten",
  "Back to applications": "Terug naar applicaties",
  "Back to categories": "Terug naar categorieën",
  "Customer and chain interaction": "Klant en keteninteractie",
  "Components overview": "Componenten overzicht",
  "No description available": "Geen beschrijving beschikbaar",
  "Search term": "Zoekterm",
  "Active Filters": "Actieve Filters",
  "Submit component or organization": "Component of organisatie indienen",
  "Register your component or organization": "Registreer uw component of organisatie in Open Catalogi",
  "Repository url of your component or organization":
    "Geef de url van de repository van uw component of organisatie op",
  "Oops, something went wrong. Please make sure you're using a valid repository URL or try again later.":
    "Oeps, er is iets misgegaan. Zorg ervoor dat je een geldige repository-URL gebruikt of probeer het later opnieuw.",
  "View Repository": "Bekijk Repository",
  "Already have a repository URL? Then register it immediately.":
    "Heb je al een repository-URL? Registreer hem dan direct.",
  "Owned, supported and used components": "Eigen, ondersteunde en gebruikte componenten",
  "No website found": "Geen website gevonden",
  "Not found": "Niet gevonden",
  "No repository found": "Geen repository gevonden",
  "Back to organizations": "Terug naar organisaties",
  "Show more": "Toon meer",
  "Show less": "Toon minder",
  "Opens a new window": "Opent een nieuw venster",
  "Markdown file": "Markdown bestand",
  "No markdown file found, make sure that the query param link is filled":
    "Geen markdown bestand gevonden, zorg er voor dat de query parameter link is gevuld",
  "All components": "Alle componenten",
  "Scroll left": "Scroll naar links",
  "Scroll right": "Scroll naar rechts",
  "Next page": "Volgende pagina",
  "Previous page": "Vorige pagina",
  "Select UPL": "Selecteer UPL",
  "Select organization": "Selecteer ogranisatie",
  "Select category": "Selecteer categorie",
  "Select license": "Selecteer licentie",
  "Select business function": "Selecteer bedrijfsfunctie",
  "Select business services": "Selecteer bedrijfsservices",
  "Select reference components": "Selecter referentiecomponenten",
  "Hide forks": "Forks verbergen",
  "Hide obsolete": "Uitgefaseerd verbergen",
  "Phone number": "Telefoonnummer",
  "No results found": "Geen resultaten gevonden",
  "No results available": "Geen resultaten beschikbaar",
  "Results per page": "Resultaten per pagina",
  "Select result limit": "Selecteer resultaten limiet",
  "Business function": "Bedrijfsfunctie",
  "Type of support": "Type ondersteuning",
  "Unknown size": "Onbekende grootte",
  "Order by rating": "Sorteren op beoordeling",
  "Left scroll button": "Linker scrollknop",
  "Right scroll button": "Rechter scrollknop",
  "No application found": "Geen applicatie gevonden",
  "Commonground rating": "Commonground beoordeling",
  "No rating": "Geen beoordeling",
  "The repository has been submitted successfully.": "De repository is met success verzonden.",
  "Show Percentages": "Toon Percentages",
  "Show Total": "Toon Aantal",
  "More information": "Meer informatie",
  "Common Ground rating": "Common Ground beoordeling",
  "This component has a rating of": "Dit component is beoordeeld met de status",
  "Back to publications": "Terug naar publicaties",
};
